import type { ServiceHttpClients } from "../../types";
import { setupActivityEndpoints } from "./activity-endpoints";
import { setupApparelEndpoints } from "./apparel-endpoints";
import { setupAuthEndpoints } from "./auth-endpoints";
import { setupFootDataEndpoints } from "./footdata-endpoints";
import { setupHealthEndpoints } from "./health-endpoints";
import { setupOrderEndpoints } from "./order-endpoints";
import { setupPermissionGroupsEndpoints } from "./permission-groups-endpoints";
import { setupPromotionCodeEndpoints } from "./promotionCode-endpoints";
import { setupReturnEndpoints } from "./return-endpoints";
import { setupStripeEndpoints } from "./stripe-endpoints";
import { setupSwaggerEndpoints } from "./swagger-endpoints";
import { setupTrainingEndpoints } from "./training-endpoints";
import { setupUserEndpoints } from "./user-endpoints";

export const setupAdminEndpoints = (clients: ServiceHttpClients) => {
	const endpoints = {
		auth: setupAuthEndpoints(clients.backend),
		activity: setupActivityEndpoints(clients.backend),
		user: setupUserEndpoints(clients.backend),
		health: setupHealthEndpoints(clients.backend),
		swagger: setupSwaggerEndpoints(clients.backend),
		footData: setupFootDataEndpoints(clients.canyon),
		order: setupOrderEndpoints(clients.canyon),
		return: setupReturnEndpoints(clients.canyon),
		stripe: setupStripeEndpoints(clients.canyon),
		permissionGroups: setupPermissionGroupsEndpoints(clients.canyon),
		promotionCode: setupPromotionCodeEndpoints(clients.canyon),
		training: setupTrainingEndpoints(clients.backend),
		apparel: setupApparelEndpoints(clients.backend),
	};

	return endpoints;
};
